export const DELIVERY_ROUTE_NAMES = {
    ADD: "DeliveryAdd",
    EDIT: "DeliveryEdit",
    LIST: "DeliveryList",
};
